var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoums(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62467 18.2413V3.75801C9.62467 2.38301 9.03801 1.83301 7.58051 1.83301H3.87717C2.41967 1.83301 1.83301 2.38301 1.83301 3.75801V18.2413C1.83301 19.6163 2.41967 20.1663 3.87717 20.1663H7.58051C9.03801 20.1663 9.62467 19.6163 9.62467 18.2413Z",
    stroke: "#0E0C0B",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 18.2413V3.75801C20.1667 2.38301 19.58 1.83301 18.1225 1.83301H14.4192C12.9617 1.83301 12.375 2.38301 12.375 3.75801V18.2413C12.375 19.6163 12.9617 20.1663 14.4192 20.1663H18.1225C19.58 20.1663 20.1667 19.6163 20.1667 18.2413Z",
    stroke: "#0E0C0B",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoums);
export default __webpack_public_path__ + "static/media/coloums.551edb6a402ecc6ac761562600d4b8c6.svg";
export { ForwardRef as ReactComponent };